export default __webpack_public_path__ + "static/media/snailpaw.d4821f85.jpeg";